// mantine
import { Radio } from '@mantine/core';
// assets
import styles from '@/modules/Integrations/components/Selection/components/List/List.module.css';

interface ListProps {
    items: string[];
    searchTerm: string;
}

const List = ({ items, searchTerm }: ListProps) =>
    items
        .filter((value) => value.includes(searchTerm))
        .map((value) => (
            <div className={styles.row} key={value}>
                <Radio label={value} value={value} />
            </div>
        ));

export default List;
